@if (resolvedCardType() === 'article') {
    <sirius-card-article
        [title]="resolvedTitle()"
        [textHtml]="resolvedTextHtml()"
        [image]="resolvedImage()"
        [link]="resolvedLink()"
        [tags]="resolvedTags()"
        [attributes]="resolvedAttributes()"
        [imageData]="imageData()"
        [date]="resolvedDate()"
        [publishedAt]="resolvedPublishedAt()"
        [contentType]="resolvedContentType()"
        (selectEvent)="onSelect()">
    </sirius-card-article>
} @else {
    <sirius-card-custom
        [title]="resolvedTitle()"
        [textHtml]="resolvedTextHtml()"
        [image]="resolvedImage()"
        [link]="resolvedLink()"
        [imageData]="imageData()"
        [contentType]="resolvedContentType()"
        (selectEvent)="onSelect()">
    </sirius-card-custom>
}
